import './App.css';
import Home from './components/home';
import {  Routes, Route, useLocation } from "react-router-dom";
import PrivacyPolicy from './components/privacyPolicy';
import { useEffect } from 'react';

function App() {
  const ScrollToTop = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  
    return null;
  };
  
  return (
    <div className="App">
    <ScrollToTop />
        <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
    </div>
  );
}

export default App;
